module.exports = __webpack_public_path__ + "img/no-preview.2cbab79c.png";